import { FieldControl } from '@signature-it/ngx-generic/enums';
import {FormField} from "./field";

export class GridField extends FormField{
    controlType = FieldControl.GRID;

    constructor(options: {} = {}) {
        super(options);
    }
}
